import { render, staticRenderFns } from "./AkApprovalStatusSelect.vue?vue&type=template&id=f184c06e&"
import script from "./AkApprovalStatusSelect.vue?vue&type=script&lang=js&"
export * from "./AkApprovalStatusSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/htdocs/comperex-webshops/src/vue-apps/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f184c06e')) {
      api.createRecord('f184c06e', component.options)
    } else {
      api.reload('f184c06e', component.options)
    }
    module.hot.accept("./AkApprovalStatusSelect.vue?vue&type=template&id=f184c06e&", function () {
      api.rerender('f184c06e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "widgets/AkApprovalStatusSelect.vue"
export default component.exports